import { useCallback } from 'react'
import ApiService from '../../services/ApiService'
import { getItem } from '../../utility/LocalStorage'

const InteractorDownloadPDF = () => {
  const lng = getItem('language') ? getItem('language').toUpperCase() : 'ID'

  const getRFQ = useCallback(
    (payload) => {
      payload.language = lng
      const filename = 'RFQ-' + payload.request_code + '.pdf'
      ApiService.fileRequest('/download-pdf/rfq', payload, filename, 'application/pdf')
    },
    [lng],
  )

  const getTransaction = useCallback(
    (payload) => {
      payload.item.language = lng
      const { subtotal_product, subtotal_weight, ...payloadRequest } = payload.item
      const filename = 'ORDER-' + payload?.item?.transaction_code + '.pdf'
      ApiService.fileRequest(
        '/download-pdf/transaction',
        payloadRequest,
        filename,
        'application/pdf',
      )
    },
    [lng],
  )

  const getInvoice = useCallback(
    (payload) => {
      payload.language = lng
      const filename = 'INVOICE-' + payload.invoice_code + '.pdf'
      ApiService.fileRequest('/download-pdf/invoice', payload, filename, 'application/pdf')
    },
    [lng],
  )

  return { getRFQ, getTransaction, getInvoice }
}

export default InteractorDownloadPDF
